import ResponseAnswerRepository from '../../../networking/repos/ResponseAnswerRepository';
import {useQueryConfig} from '../Utils';
import {ResponseAnswerKey} from './Key';

export const useResponseAnswerIndexQueryConfig = (responseId: number) => {
    const repo = new ResponseAnswerRepository(responseId);

    return useQueryConfig(ResponseAnswerKey.index({ responseId }), () => repo.all());
};
